import { Box, useMediaQuery } from '@mui/material';
import { ReactComponent as RenderNet } from 'core/assets/svg/app-bar/ic_rendernet.svg';
import Linked from 'core/components/link/Link';
import BaseTypography from 'core/components/typography/BaseTypography';
import appTheme from 'core/layouts/ui-blocks/AppTheme';
import { reusableStyles } from 'core/layouts/ui-blocks/ReusableStyles';
import { APP, CANVASES, ROOT, STUDIO, TEXT_TO_IMAGE } from 'core/navigation/Routes';
import React from 'react';
import BestViewedOnDesktop from 'core/layouts/components/best-viewed-on-desktop/BestViewedOnDesktop';
import ProfileButton from 'core/layouts/components/profile-button/ProfileButton';
import { appBarStyles } from 'core/layouts/components/app-bar/AppBarStyles';

function AppBar() {
	const currentURL = window.location.href;
	const isMobileScreen = useMediaQuery(appTheme.breakpoints.down('md'));

	function getSource() {
		if (currentURL.includes(TEXT_TO_IMAGE)) {
			return TEXT_TO_IMAGE;
		}
		if (currentURL.includes(STUDIO)) {
			return STUDIO;
		}
		if (currentURL.includes(CANVASES)) {
			return CANVASES;
		}
		return ROOT;
	}

	if (getSource() === STUDIO) return null;
	if (getSource() === TEXT_TO_IMAGE) return null;
	return (
		<Box id="app-bar-wrapper" sx={[appBarStyles.appBarWrapper]}>
			<Box id="top-header" sx={[appBarStyles.topHeader]}>
				<Box id="app-bar" sx={[appBarStyles.appBar]}>
					<Box id="logos" sx={[reusableStyles.flexRow, { gap: '32px' }]}>
						<Linked to={ROOT}>
							<Box id="app-bar-logo-cont" sx={[appBarStyles.appBarLogoCont]}>
								<RenderNet />
							</Box>
						</Linked>
						{(getSource() === STUDIO || getSource() === CANVASES) && !isMobileScreen && (
							<Linked to={ROOT}>
								<BaseTypography
									variant="t2_regular"
									styles={{
										color: 'colors.light3',
										cursor: 'pointer',
									}}
								>
									Home
								</BaseTypography>
							</Linked>
						)}
						{getSource() === STUDIO && !isMobileScreen && (
							<Linked to={`/${APP}/${CANVASES}`}>
								<BaseTypography
									variant="t2_regular"
									styles={{
										color: 'colors.light3',
										cursor: 'pointer',
									}}
								>
									Canvases
								</BaseTypography>
							</Linked>
						)}
					</Box>

					<Box id="profile-icon-cont" sx={[reusableStyles.flexRow, { gap: '20px' }]}>
						<Box
							id="profile-icon-wrapper"
							sx={[reusableStyles.flexRow, { gap: { xs: '12px', sm: '28px' } }]}
						>
							<ProfileButton />
						</Box>
					</Box>
				</Box>

				{getSource() === STUDIO && (
					<Box sx={[{ width: '100%' }, reusableStyles.mobileOnly]}>
						<BestViewedOnDesktop />
					</Box>
				)}
			</Box>
		</Box>
	);
}

export default AppBar;
